import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
  FormControl,
  InputLabel,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import { Button, Input } from "../../../../shared/ReusableComponents";
interface Field {
  label: string;
  key: string;
  type?: any;
  options?: { label: string; value: string }[];
}

interface ITelephoneOrdersDailogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  title: string;
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  fields: Field[];
  additionalContent?: React.ReactNode;
  caption: string;
  errors?: Record<string, string>;
}

const TelephoneOrdersDialog: React.FC<ITelephoneOrdersDailogProps> = ({
  open,
  onClose,
  onSubmit,
  title,
  formData,
  setFormData,
  fields,
  additionalContent,
  caption,
  errors,
}) => {
  const initialErrors: Record<string, string> = {
    common: "",
  };
  const [error, setError] = useState<typeof initialErrors>(initialErrors);
  const clearErrors = () => {
    setError(initialErrors);
  };

  const handleSubmit = () => {
    let allFieldFilled = true;
    let newErrors: Record<string, string> = { ...initialErrors };

    fields.forEach((field) => {
      if (field.key !== "initials") {
        const value = formData[field.key]?.toString().trim();
        if (!value) {
          allFieldFilled = false;
        }
      }
    });

    if (!allFieldFilled) {
      newErrors.common = "All the fields are mandatory, Please check.";
    }

    setError(newErrors);

    const hasErrors = Object.values(newErrors).some((msg) => msg.length > 0);
    if (hasErrors) {
      return;
    }
    if (allFieldFilled) {
      onSubmit();
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: string
  ) => {
    const value = e.target.value;

    if ((value.match(/\./g) || []).length > 1) {
      return; // Reject if more than one decimal is found
    }
    if (value.includes("-")) {
      return; // Reject input if it contains a hyphen
    }
    setFormData((prevState: any) => ({ ...prevState, [field]: value }));

    if (value !== "" && error.common) {
      setError((prevError) => ({
        ...prevError,
        common: "",
      }));
    }
  };

  useEffect(() => {
    if (!open) {
      clearErrors();
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg">
      <DialogTitle className="vital-title">
        {title}
        <span style={{ fontSize: "14px" }}>{caption}</span>
        <IconButton
          edge="end"
          onClick={onClose}
          aria-label="close"
          sx={{
            position: "absolute",
            right: 25,
            top: 8,
            color: "#424242",
          }}
        >
          <GridCloseIcon />
        </IconButton>
        <Box
          sx={{
            borderBottom: "2px solid var(--color-border-model)",
            marginTop: 1.4,
          }}
        />
        <Box sx={{ marginTop: "10px", fontSize: "16px" }}>
          <span>{additionalContent}</span>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ display: "flex", gap: 2, mt: "10px" }}>
          {fields.map((field) =>
            field.key === "initials" ? (
              <Input
                name=""
                key={field.key}
                label={field.label}
                value={formData[field.key]}
                InputLabelProps={{
                  style: { color: "var(--color-border-model)" },
                }}
                disabled
                size="small"
              />
            ) : field.type === "select" ? (
              <FormControl
                sx={{ minWidth: 150 }}
                size="small"
                variant="outlined"
                error={Boolean(error.common && !formData[field.key])}
              >
                <InputLabel
                  id={`${field.key}-label`}
                  // shrink
                  sx={{ backgroundColor: "white", px: 0.5, color: "#747474" }}
                >
                  Frequency *
                </InputLabel>
              </FormControl>
            ) : (
              <Input
                name=""
                key={field.key}
                label={field.label}
                value={formData[field.key]}
                hasError={error.common && !formData[field.key] ? "\u200B" : ""}
                helperText={
                  error.common && !formData[field.key] ? "" : undefined
                }
                onChange={(e) => handleChange(e, field.key)}
                required
                size="small"
                slotProps={{
                  ...(field.key === "prescribedBy" && {
                    input: {
                      startAdornment: <span className="prefixName">Dr.</span>,
                    },
                  }),
                }}
              />
            )
          )}
        </Box>
        <Box
          sx={{
            borderBottom: "2px solid var(--color-border-model)",
            marginTop: "21px",
          }}
        >
          <span style={{ color: "var(--color-error-main)" }}>
            {error.common}
          </span>
        </Box>
      </DialogContent>

      <DialogActions sx={{ padding: "0px 22px 15px 0px", columnGap: "10px" }}>
        <Button
          variant="outlined"
          onClick={onClose}
          fullWidth={false}
          text="Cancel"
        />

        <Button
          variant="contained"
          onClick={handleSubmit}
          text="Save"
          fullWidth={false}
        />
      </DialogActions>
    </Dialog>
  );
};

export default TelephoneOrdersDialog;
